export const environment = {
  "GRAPHQL_URI": 'https://skip-brain-mj-api-stage-g8bpgsc8dde2befx.centralus-01.azurewebsites.net/',
  "GRAPHQL_WS_URI": 'wss://skip-brain-mj-api-stage-g8bpgsc8dde2befx.centralus-01.azurewebsites.net/',
  "REDIRECT_URI": 'https://zealous-meadow-013739510.6.azurestaticapps.net/',
  "CLIENT_ID": 'c0b5941b-0f9d-464b-b8f9-fec15db37748',
  "TENANT_ID": "ff10ade7-5d03-40a9-be28-cb7ab99670b1",
  "CLIENT_AUTHORITY": 'https://login.microsoftonline.com/ff10ade7-5d03-40a9-be28-cb7ab99670b1',
  "AUTH_TYPE": 'msal' as const,
  "NODE_ENV": "production",
  "AUTOSAVE_DEBOUNCE_MS": 1200,
  "SEARCH_DEBOUNCE_MS": 800,
  "MIN_SEARCH_LENGTH": 3,
  "MJ_CORE_SCHEMA_NAME": "__mj",
  "production": true,
  "APPLICATION_NAME": "Skip Explorer",
  "APPLICATION_INSTANCE": "STAGE",
  "AUTH0_DOMAIN": "",
  "AUTH0_CLIENTID": ""
};